import { render, staticRenderFns } from "./ResultCard.vue?vue&type=template&id=4406f06d&scoped=true"
import script from "./ResultCard.vue?vue&type=script&lang=ts"
export * from "./ResultCard.vue?vue&type=script&lang=ts"
import style0 from "./ResultCard.vue?vue&type=style&index=0&id=4406f06d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406f06d",
  null
  
)

export default component.exports